<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Dados Gerais"
      >
        <NxInputDocument
          @update:value="handleInputUpdate('document', $event)"
        />
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)" />
        <NxInput
          name="numProtocolo"
          type="text"
          label="Número do Protocolo:"
          placeholder="Digite o Número do Protocolo:"
          @update:value="handleInputUpdate('numProtocolo', $event, false)"
        ></NxInput>
        <NxInputDateRange
          label="Período da Visita:"
          @update:InitialValue="
            handleInputDateUpdate('periodoVisitaInicial', $event, false)
          "
          @update:FinalValue="
            handleInputDateUpdate('periodoVisitaFinal', $event, false)
          "
        />
      </SearchCollapse>

      <SearchCollapse title="Instituição">
        <NxSelectPA @update:value="handleSelectUpdate('paId', $event)" />
        <NxSelectRegional
          @update:value="handleSelectUpdate('nomeRegional', $event)"
        />
        <NxSelectFuncionario
          :variable="employeeTypes.GERENTE"
          @update:value="handleSelectUpdate('gerenteId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Responsável">
        <NxSelectFuncionario
          :variable="employeeTypes.RESPONSAVELVISITA"
          @update:value="handleSelectUpdate('responsavelVisitaId', $event)"
        />
        <NxSelectFuncionario
          :variable="employeeTypes.RESPONSAVELCARD"
          @update:value="handleSelectUpdate('responsavelCardId', $event)"
        />
        <NxSelectResponsavelGrupo
          @update:value="handleSelectUpdate('gruposResponsaveisId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Produto">
        <NxSelectProduto
          @update:value="handleSelectUpdate('produtosId', $event)"
        />
        <NxInputNumberRange
          v-if="checkBoardType(boardTypes.COBRANCA)"
          label="Dias em atraso:"
          @update:InitialValue="handleInputUpdate('diasAtrasoInicio', $event)"
          @update:FinalValue="handleInputUpdate('diasAtrasoFinal', $event)"
        />
      </SearchCollapse>

      <SearchCollapse
        title="Ajuizamento"
        v-if="checkBoardType(boardTypes.AJUIZAMENTO)"
      >
        <NxInput
          name="numProcesso"
          type="number"
          label="Número do Processo:"
          placeholder="Digite o Número do Processo"
          @update:value="handleInputUpdate('numeroProcesso', $event)"
        ></NxInput>
        <NxInput
          name="instancia"
          type="text"
          label="Instancia:"
          placeholder="Digite a Instancia"
          @update:value="handleInputUpdate('instancia', $event)"
        ></NxInput>
        <NxSelectAjuizamentoAssunto
          @update:value="handleSelectUpdate('assuntoId', $event)"
        />
        <NxSelectAjuizamentoComarca
          @update:value="handleSelectUpdate('comarcaId', $event)"
        />
        <NxSelectAjuizamentoFase
          @update:value="handleSelectUpdate('faseId', $event)"
        />
        <NxSelectAjuizamentoObjetoAcao
          @update:value="handleSelectUpdate('objetoAcaoId', $event)"
        />
        <NxSelectAjuizamentoPrognostico
          @update:value="handleSelectUpdate('prognosticoId', $event)"
        />
        <NxSelectAjuizamentoAdvogado
          labelText="Advogado Responsável:"
          @update:value="handleSelectUpdate('advogadoResponsavel', $event)"
        />
        <NxSelectAjuizamentoAdvogado
          labelText="Advogado Contrário:"
          @update:value="handleSelectUpdate('advogadoContrario', $event)"
        />
        <NxInput
          name="dataDistribuicao"
          type="date"
          label="Data Distribuição:"
          :max="getCurrentDate()"
          @update:value="handleInputUpdate('dataDistribuicao', $event, false)"
        ></NxInput>
        <NxInput
          name="dataAndamento"
          type="date"
          label="Último Andamento:"
          :max="getCurrentDate()"
          @update:value="handleInputUpdate('ultimoAndamento', $event, false)"
        ></NxInput>
      </SearchCollapse>

      <!-- <SearchCollapse title="Redes Sociais">
        <NxInput
        name="utmCampaign"
        type="text"
        label="UTM Campaign:"
        placeholder="Digite o UTM Campaign"
      ></NxInput>
      </SearchCollapse> -->
    </SidebarSearch>
  </div>
</template>

<script>
import {
  NxInputDocument,
  NxInputName,
  NxInputNumberRange
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectAjuizamentoAssunto,
  NxSelectAjuizamentoComarca,
  NxSelectAjuizamentoAdvogado,
  NxSelectAjuizamentoFase,
  NxSelectAjuizamentoObjetoAcao,
  NxSelectAjuizamentoPrognostico,
  NxSelectFuncionario,
  NxSelectPA,
  NxSelectProduto,
  NxSelectRegional,
  NxSelectResponsavelGrupo
} from '@/components/nexum/components/custom-selects/index.js'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import boardTypes from '@/enums/enumBoardTypes.js'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import NxInputDateRange from '../../../../../../components/nexum/components/custom-inputs/NxInputDateRange.vue'

export default {
  name: 'SidebarAcompanhamento',
  components: {
    NxInputDateRange,
    SidebarSearch,
    SearchCollapse,
    NxSelectPA,
    NxSelectRegional,
    NxSelectFuncionario,
    NxSelectAjuizamentoAssunto,
    NxSelectResponsavelGrupo,
    NxSelectAjuizamentoComarca,
    NxSelectAjuizamentoAdvogado,
    NxSelectAjuizamentoFase,
    NxSelectAjuizamentoObjetoAcao,
    NxSelectAjuizamentoPrognostico,
    NxSelectProduto,
    NxInputDocument,
    NxInputName,
    NxInputNumberRange
  },
  props: {
    board: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        document: null,
        paId: null,
        nomeRegional: null,
        gerenteId: null,
        responsavelVisitaId: null,
        responsavelCardId: null,
        gruposResponsaveisId: null,
        produtosId: null,
        diasAtrasoInicio: null,
        diasAtrasoFinal: null,
        numeroProcesso: null,
        instancia: null,
        assuntoId: null,
        comarcaId: null,
        faseId: null,
        objetoAcaoId: null,
        prognosticoId: null,
        advogadoResponsavel: null,
        advogadoContrario: null,
        dataDistribuicao: null,
        ultimoAndamento: null,
        numProtocolo: null,
        periodoVisitaInicial: null,
        periodoVisitaFinal: null
      },
      boardTypes: boardTypes,
      employeeTypes: employeeTypes
    }
  },
  methods: {
    debugLog () {
      console.log(this.form)
    },
    submitForm () {
      // TODO: encode the name before sendind it
      // this.form.nome = encodeURIComponent(this.form.nome)
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      console.log(this.form.nome)
      this.form[dataPropName] = encodeURIComponent(value)
      console.log(this.form.nome)
    },
    checkBoardType (typeDesired) {
      let currentType = this.board.tipoBoard
      return typeDesired === currentType
    },
    getCurrentDate () {
      let date = new Date()
      let day = String(date.getDate()).padStart(2, '0')
      let month = String(date.getMonth() + 1).padStart(2, '0')
      let year = date.getFullYear()

      let currentDate = year + '-' + month + '-' + day

      return currentDate
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map((v) => (v.hasOwnProperty('value') ? v.value : v))
          : selectedValue.hasOwnProperty('value')
            ? selectedValue.value
            : selectedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let newDate = new Date(inputedValue)
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/acompanhamento/search/SidebarAcompanhamento.vue